import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { NFLookupProduct } from "../../../Shared/NewForms/NFLookupProduct";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { NFLookupAccount } from "../../../Shared/NewForms/NFLookupAccount";
import { NFLookupUnit } from "../../../Shared/NewForms/NFLookupUnit";

export const ProductionAndSalesDetailCosts = () => {
    const tableName = "products";
    const { t } = useTranslation();

    useEffect(() => {}, []);

    return (
        <>
            <NFormTable fieldArray={"costs"}>
                <NFLookupUnit title={t("Unit")} fieldName="unitId" />
                <NFIntInput title={t("Quantity")} fieldName="quantity" />
                <NFIntInput title={t("Price")} fieldName="price" />
                <NFIntInput title={t("Amount")} fieldName="amount" />
                <NFLookupAccount
                    title={t("CostAccount")}
                    fieldName="costAccountId"
                />
                <NFLookupProduct title={t("Product")} fieldName="productId" />
            </NFormTable>
        </>
    );
};
